import { combineReducers } from 'redux';
import { amReducer } from './am/am.reducer';

const clientReducer = combineReducers({
    am: amReducer,
});

export default clientReducer;
